export default __webpack_public_path__ + "static/media/poly-plus-license.12c9f2a5.svg";